import type { ProgressRepository } from "../../domain/progress/progress-repository";
import { LocalStorageProgressRepository } from "./local-storage-progress-repository";
import { InMemoryProgressRepository } from "./memory-progress-repository";

const STORAGE_PROBE_KEY = "__vimquest_storage_probe__";

/**
 * 与えられた `Storage` が実際に使用可能かを判定する。プライベートモード等では
 * `localStorage` の参照自体は取得できても `setItem` が例外を投げる場合があるため、
 * 実際に書き込みを試して確認する。
 */
export function isStorageAvailable(storage: Storage): boolean {
  try {
    storage.setItem(STORAGE_PROBE_KEY, STORAGE_PROBE_KEY);
    storage.removeItem(STORAGE_PROBE_KEY);
    return true;
  } catch {
    return false;
  }
}

/**
 * `ProgressRepository` の実装を環境に応じて選択するファクトリ（F-008）。
 * localStorageが使用可能ならそれを、不可能ならメモリ実装へフォールバックする。
 */
export function createProgressRepository(
  storage: Storage = window.localStorage,
): ProgressRepository {
  return isStorageAvailable(storage)
    ? new LocalStorageProgressRepository(storage)
    : new InMemoryProgressRepository();
}
